import { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'modules/state-mgmt/store';
import { fetchWorkerCompaniesRequirements } from 'modules/state-mgmt/workerData';
import { ComputedRequirements, computeRequirements } from '../utils/requirementsCalculation';
import { Project } from '../types';
import { enqueueSnackbar } from 'notistack';
import { prettifyErrorResponse } from 'utils';

export const useMissingRequirements = () => {
  const dispatch = useAppDispatch();
  const workerId = useAppSelector(state => state.onboarding?.id || state.user?.workerId);

  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [requirementData, setRequirementData] = useState<ComputedRequirements | null>(null);

  const handleView = async (project: Project) => {
    const projectId = project?.project?.id;
    const companyIds = project?.companies?.map(c => c?.company?.id).filter(Boolean) as string[];
    if (!workerId || !projectId) return;
    setRequirementData(null);
    setShowModal(true);
    setIsLoading(true);
    try {
      const raw = await dispatch(fetchWorkerCompaniesRequirements({ workerId, projectId, companyIds })).unwrap();
      setRequirementData(computeRequirements(raw));
    } catch (error) {
      enqueueSnackbar(prettifyErrorResponse(error), { variant: 'error' });
      setShowModal(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => setShowModal(false);

  return { showModal, isLoading, requirementData, handleView, handleClose };
};
